export default {
  namespaced: true,
  state: {
    isPreloaderVisible: false,
  },
  mutations: {
    SET_VISIBLE_PRELOADER(state) {
      state.isPreloaderVisible = true;
    },
    SET_INVISIBLE_PRELOADER(state) {
      state.isPreloaderVisible = false;
    },
  },
};
